const HarvestActivityActionTypes = {
	CLEAR_ERROR: "CLEAR_ERROR",
	// Fetch Harvest Activities
	FETCH_HARVEST_ACTIVITIES_START: "FETCH_HARVEST_ACTIVITIES_START",
	FETCH_HARVEST_ACTIVITIES_SUCCESS: "FETCH_HARVEST_ACTIVITIES_SUCCESS",
	FETCH_HARVEST_ACTIVITIES_FAILURE: "FETCH_HARVEST_ACTIVITIES_FAILURE",
};

export default HarvestActivityActionTypes;
